import QueryString from 'qs'
import { apiClient } from '../client'
import {
    NotificationActiveTabs,
    NotificationDeliveriesParams,
    NotificationDeliveriesResponse,
    NotificationPreferencesResponse,
    NotificationPreferencesUpdateParams,
    NotificationPreferencesUpdateResponse,
    NotificationUnreadCountResponse,
    NotificationUpdateParams,
    NotificationUpdateResponse,
} from './types'

export const getNotificationDeliveries = async (params: NotificationDeliveriesParams = {}) => {
    const response = await apiClient(`v1/notification-system/deliveries`, {
        params,
        paramsSerializer: (params: NotificationDeliveriesParams) => {
            return QueryString.stringify(params)
        },
    })

    return response?.data as NotificationDeliveriesResponse
}

export const getTotalUnreadCount = async () => {
    const response = await apiClient(`v1/notification-system/deliveries/unread-count`)
    return response?.data as NotificationUnreadCountResponse
}

export const dismissNotifications = async (params: NotificationUpdateParams) => {
    const response = await apiClient(`v1/notification-system/deliveries/dismiss`, {
        method: 'PATCH',
        data: params,
    })

    return response?.data as NotificationUpdateResponse
}

export const toggleMarkAsRead = async (params: NotificationUpdateParams) => {
    const response = await apiClient(`v1/notification-system/deliveries/toggle-read`, {
        method: 'PATCH',
        data: params,
    })

    return response?.data as NotificationUpdateResponse
}

export const getNotificationActiveTabs = async () => {
    const response = await apiClient(`v1/notification-system/notifications`)
    return response?.data as NotificationActiveTabs
}

export const getAgentPreferences = async (agentId: string) => {
    const response = await apiClient(agentId ? `v1/notification-system/agents/${agentId}/preferences` : `v1/notification-system/preferences`)
    return response?.data as NotificationPreferencesResponse
}

export const updateAgentPreferences = async (agentId: string, params: NotificationPreferencesUpdateParams) => {
    const response = await apiClient(`v1/notification-system/agents/${agentId}/preferences`, {
        method: 'PUT',
        data: params,
    })
    return response?.data as NotificationPreferencesUpdateResponse
}

export const restoreNotifications = async (params: { deliveryIds: number[] }) => {
    const response = await apiClient(`v1/notification-system/deliveries/restore`, {
        method: 'PATCH',
        data: params,
    })
    return response?.data as NotificationUpdateResponse
}
